{
  "title": "Create New Account",
  "selectAccount": "Select Account Type",
  "accountHolder": "Account Holder",
  "accountSummary": {
    "added": "You've successfully added a new account",
    "failed": "Adding a new account failed.",
    "subAccMsg": "Let's connect this account to a sub-account"
  },
  "actions": {
    "createNewAccount": "Create New Account",
    "createSubAccount": "Create Sub-account"
  },
  "govFundOptions": {
    "ADDITIONAL_CESG": "Additional CESG",
    "BASIC_CESG": "Basic Canada Education Savings Grant",
    "CLB": "Canada Learning Bond"
  },
  "isTransferredFromAnotherInstitution": "Transferred from another institution",
  "yes": "Yes",
  "no": "No",
  "sourceOfFundsOptions": {
    "SELF": "Self",
    "SPOUSE": "Spouse",
    "USA_EMPLOYMENT_WAGES": " Employment Wages",
    "USA_INHERITANCE_TRUST": " Inheritance / Trust",
    "USA_LOTTERY_GAMING": "Lottery / Gaming",
    "USA_RETIREMENT_FUNDS": "Retirement Funds",
    "USA_INVESTMENTS": "Investments",
    "USA_SPOUSAL_PARENTAL_SUPPORT": "Spousal / Parental Support",
    "USA_GIFT": "Gift",
    "USA_SAVINGS": "Savings",
    "USA_UNEMPLOYMENT_DISABILITY": " Unemployment / Disability",
    "USA_LEGAL_SETTLEMENT": "Legal Settlement",
    "USA_OTHER": "Other"
  },
  "sourceOfFunds": "Source of Funds",
  "jurisdiction": "Jurisdiction",
  "custodianAccountNumber": "Custodian Account Number",
  "feeGridTitle": "Fee Grid",
  "billingCycleTitle": "Billing Cycle",
  "householdClientGroup": "Household",
  "federal": "Federal",
  "messages": {
    "setUpSubAccount": "Next, let's setup your sub-account",
    "requireAffiliate": "This account type requires at least 1 affiliate"
  },
  "outlineText": {
    "skipForSubAccount": "Skip for now, and create sub-account",
    "skipNow": "Skip for now"
  },
  "repCode": "Rep Code"
}
